import { render, staticRenderFns } from "./ReRegisterDigiBoardLicence.vue?vue&type=template&id=8430cca0&scoped=true"
import script from "./ReRegisterDigiBoardLicence.vue?vue&type=script&lang=js"
export * from "./ReRegisterDigiBoardLicence.vue?vue&type=script&lang=js"
import style0 from "./ReRegisterDigiBoardLicence.vue?vue&type=style&index=0&id=8430cca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8430cca0",
  null
  
)

export default component.exports